import request from '@/utils/request';

/**
 * 周签到列表
 * @param params
 */
export function weeklySignListApi(params) {
  return request({
    url: 'admin/platform/userSign/config/list',
    method: 'GET',
    params: params
  });
}

/**
 * 新增周签到
 * @param data
 */
export function weeklySignCreateApi(data) {
  return request({
    url: 'admin/platform/userSign/config/create',
    method: 'POST',
    data: data
  });
}

/**
 * 编辑周签到
 * @param data
 */
export function weeklySignUpdateApi(data) {
  return request({
    url: 'admin/platform/userSign/config/update',
    method: 'POST',
    data: data
  });
}

/**
 * 删除周签到
 */
export function weeklySignDeleteApi(data) {
  return request({
    url: "admin/platform/userSign/config/delete",
    method: 'POST',
    data: data
  });
}

/**
 * 周签到详情
 * @param id
 */
export function weeklySignDetailApi(id) {
  return request({
    url: "admin/platform/userSign/config/detail/".concat(id),
    method: 'GET'
  });
}